import React, { useEffect } from 'react';
import logom from '../assests/imgs/Logos/Logos/Cream Logomark.png';


export default function Hero() {

  useEffect(()=>{
    
  },[])


  
  return (
    <>
    <div className='hero'>
      






      <div className='hero-text'  >
      <div className='logomark'>
        <div className='img-container'> 
          <div className='img'>
            <img src={logom} alt='lm' />
          </div>
          <div className='img-overlay'></div>
            <div className='img-blocks'>
            {Array.from({ length: 400 }).map((_, index) => (
              <div key={index} className="block"></div>
            ))}
            </div>

        </div>
      </div>
        <p data-aos="fade-left">We are a unique<br/>
        combination of engineering,<br/>
        construction, and design.</p>
    </div>
    <h2   data-aos="fade-up" 
         data-aos-anchor-placement="bottom-bottom" 
         data-aos-delay="500">
        Emerging Design & Build <br/>
        Contractor. Engineering your <br/>
        dreams with us.
    </h2>
    </div>
    
    </>
  )
}
